const isValidYoutubeUrl = (url: string): boolean => {
  try {
    const urlObj = new URL(url);

    const validDomains = [
      'youtube.com',
      'www.youtube.com',
      'm.youtube.com',
      'youtube-nocookie.com',
      'youtu.be',
      'www.youtu.be',
    ];

    if (!validDomains.some((domain) => urlObj.hostname.endsWith(domain))) {
      return false;
    }

    const videoIdRegex = /^[a-zA-Z0-9_-]{11}$/;

    if (urlObj.pathname === '/watch') {
      const videoId = urlObj.searchParams.get('v');
      return videoId !== null && videoIdRegex.test(videoId);
    }

    if (urlObj.hostname.includes('youtu.be')) {
      const videoId = urlObj.pathname.slice(1);
      return videoIdRegex.test(videoId);
    }

    if (urlObj.pathname.startsWith('/shorts/')) {
      const videoId = urlObj.pathname.replace('/shorts/', '');
      return videoIdRegex.test(videoId);
    }

    if (urlObj.pathname.startsWith('/embed/')) {
      const videoId = urlObj.pathname.replace('/embed/', '');
      return videoIdRegex.test(videoId);
    }

    if (urlObj.pathname.startsWith('/v/')) {
      const videoId = urlObj.pathname.replace('/v/', '');
      return videoIdRegex.test(videoId);
    }

    return false;
  } catch (error) {
    return false;
  }
};

export const getYouTubeId = (url: string): string | null => {
  try {
    const parsedURL = new URL(url);

    if (
      parsedURL.hostname.includes('youtube.com') ||
      parsedURL.hostname.includes('m.youtube.com')
    ) {
      const videoID = parsedURL.searchParams.get('v');
      if (videoID) {
        return videoID;
      }

      const shortsMatch = parsedURL.pathname.match(
        /\/shorts\/([a-zA-Z0-9_-]{11})/
      );
      if (shortsMatch) {
        return shortsMatch[1];
      }

      const embedMatch = parsedURL.pathname.match(
        /(?:\/embed\/|\/v\/)([a-zA-Z0-9_-]{11})/
      );
      if (embedMatch) {
        return embedMatch[1];
      }
    }

    if (parsedURL.hostname === 'youtu.be') {
      const videoID = parsedURL.pathname.substring(1);
      if (videoID.length === 11) {
        return videoID;
      }
    }

    return null;
  } catch (error) {
    return null;
  }
};

const getYouTubeTitle = async (url: string): Promise<string | null> => {
  try {
    const videoId = getYouTubeId(url);
    if (!videoId) return null;

    const oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;

    const response = await fetch(oEmbedUrl);
    if (!response.ok) throw new Error('Failed to fetch video title');

    const data = await response.json();
    return data.title;
  } catch (error) {
    return null;
  }
};

export { getYouTubeTitle, isValidYoutubeUrl };
